module.exports = __webpack_public_path__ + "static/media/success.bcd1a436.png";